<h1 mat-dialog-title>Remove product</h1>
<div mat-dialog-content>
  The product has dependant telemetry tanks please give a replacement code
  <br/><br/>
  <strong>{{data.title}} ({{data.code}})</strong>
  <br/><br/>
  <input *ngIf="data.replacement" matInput [(ngModel)]="replacementCode" name="replacementCode" placeholder="Replacement product code"/>
</div>
<div mat-dialog-actions >
  <button (click)="onConfirm(data.id)" mat-button cdkFocusInitial>Ok</button>
  <button mat-button mat-dialog-close>Cancel</button>
</div>

